export const DELIVERY_CHANGE_REASONS = [
    {
        id: 'unintentionalChangeTiempo',
        value: 'tiempoentrega-UNINTENTIONAL_CHANGE',
        label: 'Tiempo de entrega',
    },
    {
        id: 'unintentionalChangeAcuerdo',
        value: 'acuerdo-UNINTENTIONAL_CHANGE',
        label: 'Acuerdo entre repartidores',
    },
    {
        id: 'unintentionalChangeRuta',
        value: 'ruta-UNINTENTIONAL_CHANGE',
        label: 'Beneficio de ruta',
    },
    {
        id: 'unintentionalChangeBalanceo',
        value: 'balanceo-UNINTENTIONAL_CHANGE',
        label: 'Balanceo de botellones',
    },
    {
        id: 'intentionalChange',
        value: 'sinmotivo-INTENTIONAL_CHANGE',
        label: 'Sin motivo / acuerdo',
    },
];
